import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
import { FaMedapps } from "react-icons/fa";
import { FaImage } from "react-icons/fa";
import { FaCode } from "react-icons/fa";
import { FaTerminal } from "react-icons/fa";
import { FaFirefox } from "react-icons/fa";
import { FaAdobe } from "react-icons/fa";

const About = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div className="container px-10 mx-auto my-20">
      <div data-aos="fade-down" className=" pb-8">
        <h1 className=" font-bold text-4xl md:text-5xl lg:text-6xl">About</h1>
      </div>

      <div>
        <div
          data-aos="fade-left"
          
          className="card rounded bg-green-200 hover:shadow-lg border-l-4 border-red-200"
        >
          <div className="m-4">
            <h1 className="leading-loose text-black p-10 sm:text-base md:text-2xl lg:text-2xl">
              I am a front-end developer and Curious about Web Application
              Development & Security.Expertise in developing Web Application using HTML5, CSS3, Javascript, ES6, Python, ReactJs, NodeJs, ExpressJs, MongoDB. I like to work with javascript and its
              framework(ReactJs). I always like to learn about trending
              technologies.
              <br />
              <br />
              
              My current focus is on Backend development with Node.js and Flask.
            </h1>
          </div>
        </div>

        <div
          data-aos="fade-right"
          className="card rounded bg-purple-200 hover:shadow-lg border-l-4 border-purple-300"
        >
          <div className="m-4">
            <h1 className="pt-10 px-10  mb-2 font-bold text-2xl md:text-2xl lg:text-2xl">
              Current Tech Stack
            </h1>
            <div className="text-black  p-10 sm:text-base md:text-2xl lg:text-2xl">
              <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-x-8 gap-y-12">
                <div
                  data-aos="fade-left"
                  className="rounded border-t-4 border-indigo-400 card bg-blue-200 hover:shadow-lg"
                >
                  <div className="m-4">
                    <h1 className="py-3 text-xl font-bold flex">ReactJs</h1>
                  </div>
                </div>
                <div
                  data-aos="fade-right"
                  className="rounded border-t-4 border-red-400 card bg-purple-300 hover:shadow-lg"
                >
                  <div className="m-4">
                    <h1 className="py-3 text-xl font-bold flex">Redux</h1>
                  </div>
                </div>
                <div
                  data-aos="fade-left"
                  className="rounded border-t-4 border-blue-400 card bg-indigo-50 hover:shadow-lg"
                >
                  <div className="m-4">
                    <h1 className="py-3 text-xl font-bold flex">MongoDB</h1>
                  </div>
                </div>
                <div
                  data-aos="fade-right"
                  className="rounded border-t-4 border-gray-400 card bg-green-100 hover:shadow-lg"
                >
                  <div className="m-4">
                    <h1 className="py-3 text-xl font-bold flex">Tailwind</h1>
                  </div>
                </div>

                <div
                  data-aos="fade-left"
                  className="rounded border-t-4 border-purple-400 card bg-red-100 hover:shadow-lg"
                >
                  <div className="m-4">
                    <h1 className="py-3 text-xl font-bold flex">ExpressJS</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center my-10">
        <Link to="/onlineresume">
          <button className="animate-bounce  bg-gray-800  font-semibold text-white py-2 px-4 border border-gray-800 ">
            Online Resume
          </button>
        </Link>
      </div>

      {/* USES */}

      <div data-aos="fade-down" className="border-b-2 border-gray-200 pb-8">
        <h1 className=" font-bold text-4xl md:text-5xl lg:text-6xl">Uses</h1>
      </div>

      <div>
        <p className="flex pt-14 pb-4">
          <FaArrowRight className=" mt-1  text-green-500  sm:text-xl md:text-xl lg:text-xl" />
          <p className=" font-bold text-xl md:text-xl lg:text-xl">
            some softwares tools I use in my daily life as a Developer.
          </p>
        </p>
      </div>

      <div
       data-aos="fade-up"
       className="grid pb-10 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
        <div
          data-aos="fade-right"
          className="card bg-pink-200 hover:shadow-lg rounded border-t-4 border-indigo-400"
        >
          <div className="m-4 text-center">
            <div className=" ">
              <FaCode className="text-blue-800 mx-auto  sm:text-4xl md:text-6xl lg:text-6xl" />
            </div>
            <div className="py-1 ">
              <p className="sm:text-2xl md:text-3xl lg:text-4xl">Editor</p>
              <li className="sm:text-xl md:text-xl lg:text-xl">Vscode</li>
              <li className="sm:text-xl md:text-xl lg:text-xl">
                SynthWave '84(theme)
              </li>
            </div>
          </div>
        </div>

        <div
          data-aos="fade-left"
          className="card bg-purple-200 hover:shadow-lg rounded border-t-4 border-pink-400"
        >
          <div className="m-4 text-center">
            <div className=" ">
              <FaFirefox className="text-red-700 mx-auto  sm:text-4xl md:text-6xl lg:text-6xl" />
            </div>
            <div className="py-1 ">
              <p className="sm:text-2xl md:text-3xl lg:text-4xl">Browsers</p>
              <li className="sm:text-xl md:text-xl lg:text-xl">Firefox</li>
              <li className="sm:text-xl md:text-xl lg:text-xl">Google Crome</li>
            </div>
          </div>
        </div>

        <div
          data-aos="fade-right"
          className="card bg-blue-200 hover:shadow-lg rounded border-t-4 border-yellow-400"
        >
          <div className="m-4 text-center">
            <div className=" ">
              <FaAdobe className="text-purple-700 mx-auto  sm:text-4xl md:text-6xl lg:text-6xl" />
            </div>
            <div className="py-1 ">
              <p className="sm:text-2xl md:text-3xl lg:text-4xl">Design</p>
              <li className="sm:text-xl md:text-xl lg:text-xl">
                Abobe Illustrator
              </li>
              <li className="sm:text-xl md:text-xl lg:text-xl">Canva</li>
            </div>
          </div>
        </div>

        <div
          data-aos="fade-left"
          className="card bg-red-200 hover:shadow-lg rounded border-t-4 border-green-400"
        >
          <div className="m-4 text-center">
            <div className=" ">
              <FaTerminal className="text-gray-700 mx-auto  sm:text-4xl md:text-6xl lg:text-6xl" />
            </div>
            <div className="py-1 ">
              <p className="sm:text-2xl md:text-3xl lg:text-4xl">Terminal</p>
              <li className="sm:text-xl md:text-xl lg:text-xl">
                Windows PowerShell
              </li>
              <li className="sm:text-xl md:text-xl lg:text-xl">Git Bash</li>
            </div>
          </div>
        </div>
      </div>

      {/* Tools */}

      <div data-aos="fade-down" className=" border-b-2 border-gray-200 pb-8">
        <h1 className=" font-bold text-4xl md:text-5xl lg:text-6xl">
          Resources & Tools
        </h1>
      </div>

      <div>
        <p className="flex pt-14 pb-4">
          <FaArrowRight className=" mt-1  text-green-500  sm:text-xl md:text-xl lg:text-xl" />
          <p className=" font-bold text-xl md:text-xl lg:text-xl">
            Some tools I built to make my coding life easier!
          </p>
        </p>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-x-8 gap-y-12">
        <div
          data-aos="fade-right"
          className="card bg-indigo-300 hover:shadow-lg rounded border-t-4 border-pink-400"
        >
          <div className="m-4 text-center">
            <div className=" ">
              <FaMedapps className="text-blue-500 mx-auto  sm:text-4xl md:text-6xl lg:text-6xl" />
            </div>
            <div className="py-1 ">
              <p className="sm:text-4xl md:text-3xl lg:text-4xl">Todo Task</p>
            </div>
          </div>
        </div>

        <div
          data-aos="fade-left"
          className="card bg-purple-300 hover:shadow-lg rounded border-t-4 border-indigo-400"
        >
          <div className="m-4 text-center">
            <div className=" ">
              <FaImage className="text-purple-500 mx-auto  sm:text-4xl md:text-6xl lg:text-6xl" />
            </div>
            <div className="py-1 sm:text-4xl md:text-3xl lg:text-4xl">
              <p className="sm:text-4xl md:text-3xl lg:text-4xl">ImageUrl</p>
            </div>
          </div>
        </div>
      </div>

      {/* resources */}

      <div>
        <p className="flex pt-14  ">
          <FaArrowRight className=" mt-1  text-green-500  sm:text-xl md:text-xl lg:text-xl" />
          <p className=" font-bold text-xl md:text-xl lg:text-xl">
            some resources I use for developing my web applications
          </p>
        </p>
      </div>

      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 py-4 gap-x-8 gap-y-12">
        <div>
          <div data-aos="fade-up" className="mx-auto ">
            <div class="max-w-lg border-b-4 border-green-500 rounded overflow-hidden shadow-lg">
              <img class="w-full h-48" src="/img/waves.jpg" alt="" />
              <div class="px-6 py-4">
                <h1 class="font-bold text-xl mb-2">Make some waves!</h1>

                <p className="py-1 text-sm font-bold flex">
                  <FaExternalLinkAlt className=" px-1 text-gray-500  sm:text-xl md:text-2xl lg:text-2xl" />
                  <a
                    class="text-gray-700 text-base"
                    href="https://getwaves.io/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://getwaves.io/
                  </a>
                </p>
              </div>
              <div class="px-6 pt-4 pb-2"></div>
            </div>
          </div>
        </div>

        <div>
          <div className="pb-4">
            <div
              data-aos="fade-right"
              className="card rounded border-t-4 border-pink-500 bg-blue-100 hover:shadow-lg"
            >
              <div className=" flex ">
                <div>
                  <img
                    className="w-48 h-full object-fill"
                    src="/img/undrow.jpg"
                    alt=""
                  />
                </div>
                <div className="px-4">
                  <h1 class="font-bold text-xl mb-2">unDraw</h1>

                  <p className="py-1 text-sm font-bold flex">
                    <FaExternalLinkAlt className=" px-1 text-gray-500  sm:text-xl md:text-2xl lg:text-2xl" />
                    <a
                      class="text-gray-700 text-base"
                      href="https://undraw.co/illustrations"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://undraw.co/illustrations
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="pb-4">
            <div
              data-aos="fade-right"
              className="card rounded border-t-4 border-blue-500 bg-blue-100 hover:shadow-lg"
            >
              <div className=" flex ">
                <div>
                  <img
                    className="w-48 h-full object-fill"
                    src="/img/imgbb.jpg"
                    alt=""
                  />
                </div>
                <div className="px-4">
                  <h1 class="font-bold text-xl mb-2">
                    Upload and share your images.
                  </h1>

                  <p className="py-1 text-sm font-bold flex">
                    <FaExternalLinkAlt className=" px-1 text-gray-500  sm:text-xl md:text-2xl lg:text-2xl" />
                    <a
                      class="text-gray-700 text-base"
                      href="https://imgbb.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://imgbb.com/
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="pb-4">
            <div
              data-aos="fade-right"
              className="card rounded border-t-4 border-indigo-500 bg-blue-100 hover:shadow-lg"
            >
              <div className=" flex ">
                <div>
                  <img
                    className="w-48 h-full object-fill"
                    src="/img/react icons.jpg"
                    alt=""
                  />
                </div>
                <div className="px-4">
                  <h1 class="font-bold text-xl mb-2">React Icons</h1>

                  <p className="py-1 text-sm font-bold flex">
                    <FaExternalLinkAlt className=" px-1 text-gray-500  sm:text-xl md:text-2xl lg:text-2xl" />
                    <a
                      class="text-gray-700 text-base"
                      href="https://react-icons.github.io/react-icons"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://react-icons.github.io/react-icons
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
